import { FileCode } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FileCodeIcon = createLucideIcon(FileCode);
